import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "m13.334 2 .133.013a.667.667 0 0 1 0 1.307l-.133.014H2.667a.667.667 0 0 1 0-1.334zM13.334 12.666l.133.014a.667.667 0 0 1 0 1.307l-.133.013H2.667a.667.667 0 0 1 0-1.334zM11.333 7.333a.666.666 0 0 0-.666-.666H5.333a.666.666 0 0 0-.666.666v1.334a.666.666 0 0 0 .666.666h5.334a.666.666 0 0 0 .666-.666zm1.334 1.334a2 2 0 0 1-2 2H5.333a2 2 0 0 1-2-2V7.333a2 2 0 0 1 2-2h5.334a2 2 0 0 1 2 2z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })